<header>
  <app-header-cmp></app-header-cmp>
</header>
<div class="reports-layout">
  <div class="reports-panels">

    <div class="section-panel department-panel" [routerLink]="['/reports/department']"
         [ngClass]="{ 'active': selectedPanel === 'department' }">
      <!-- <img [src]="constants.assetsPath + '/img/icons/sitemap-grey.svg'"
           class="icon icon-default" />
      <img [src]="constants.assetsPath + '/img/icons/sitemap-gold.svg'"
           class="icon icon-active" /> -->
      <span class="panel-title">
        <span>department</span>
      </span>
    </div>

    <div class="section-panel team-panel" [routerLink]="['/reports/team']"
         [ngClass]="{ 'active': selectedPanel === 'team' }">
      <!-- <img [src]="constants.assetsPath + '/img/icons/people-carry-grey.svg'"
           class="icon icon-default" />
      <img [src]="constants.assetsPath + '/img/icons/people-carry-gold.svg'"
           class="icon icon-active" /> -->
      <span class="panel-title">
        <span>team</span>
      </span>
    </div>

    <div class="section-panel backlog-panel" [routerLink]="['/reports/backlog']"
         [ngClass]="{ 'active': selectedPanel === 'backlog' }">
      <!-- <img [src]="constants.assetsPath + '/img/icons/table-grey.svg'"
           class="icon icon-default" />
      <img [src]="constants.assetsPath + '/img/icons/table-gold.svg'"
           class="icon icon-active" /> -->
      <span class="panel-title">
        <span>backlog</span>
      </span>
    </div>

    <div class="section-panel custom-panel" [routerLink]="['/reports/custom']"
         [ngClass]="{ 'active': selectedPanel === 'custom' }">
      <!-- <img [src]="constants.assetsPath + '/img/icons/pencil-ruler-grey.svg'"
           class="icon icon-default" />
      <img [src]="constants.assetsPath + '/img/icons/pencil-ruler-gold.svg'"
           class="icon icon-active" /> -->
      <span class="panel-title">
        <span>custom</span>
      </span>
    </div>

  </div>
  <!-- <i class="fas fa-address-book"></i> -->
  <div class="panel-container">
    <router-outlet></router-outlet>
  </div>
</div>
